
import { useEffect } from 'react';

export default function OverOns() {
  // Add Schema.org JSON-LD for About page
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "Over StarSales B.V.",
      "description": "Leer meer over StarSales B.V., ons team en onze missie om ZZP en kleine bedrijven te helpen groeien online",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/over-ons`,
      "mainEntity": {
        "@type": "Organization",
        "name": "StarSales B.V.",
        "description": "Bij StarSales B.V. combineren we strak design met datagedreven marketing. Wij maken sites die klanten aantrekken en campagnes die renderen.",
        "foundingDate": "2019",
        "numberOfEmployees": "5",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Mgr. Cornelis Veermanlaan 63",
          "addressLocality": "Volendam",
          "postalCode": "1131 KE",
          "addressCountry": "NL"
        }
      }
    });
    document.head.appendChild(script);

    // Add page-specific meta tags
    document.title = "Over Ons - StarSales B.V. | Ons Team & Missie";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Leer meer over StarSales B.V., ons ervaren team en onze missie om ZZP en kleine bedrijven te helpen groeien met websites en online marketing.');
    }

    return () => {
      document.head.removeChild(script);
      document.title = "StarSales B.V. – Websites & Online Marketing voor ZZP en MKB | Volendam";
      if (metaDescription) {
        metaDescription.setAttribute('content', 'Websites, Google Ads en social media advertenties voor ZZP en kleine bedrijven. Vraag een gratis marketingcheck aan. ✓ Snel live ✓ Meetbare resultaten');
      }
    };
  }, []);

  const teamMembers = [
    {
      name: "Daan de Jong",
      role: "Oprichter/Strategisch Lead",
      image: "https://public.readdy.ai/ai/img_res/71f40f0017a4e7403646d86e5bdde7af.jpg"
    },
    {
      name: "Leyla Özdemir",
      role: "Social Media Expert",
      image: "https://readdy.ai/api/search-image?query=Professional%20Turkish%20female%20social%20media%20marketing%20expert%20headshot%2C%20young%20woman%20with%20dark%20hair%2C%20creative%20professional%2C%20modern%20workspace%20background%2C%20friendly%20smile%2C%20business%20casual%20attire%2C%20confident%20expression&width=300&height=300&seq=leyla-female&orientation=squarish"
    },
    {
      name: "Sanne van Dijk",
      role: "Webdesign Expert",
      image: "https://readdy.ai/api/search-image?query=Professional%20web%20designer%20headshot%2C%20creative%20professional%2C%20modern%20design%20studio%20background%2C%20artistic%20flair%2C%20contemporary%20business%20attire&width=300&height=300&seq=sanne&orientation=squarish"
    },
    {
      name: "Bram Visser",
      role: "Administratie",
      image: "https://readdy.ai/api/search-image?query=Professional%20administrative%20specialist%20headshot%2C%20organized%20professional%2C%20clean%20office%20background%2C%20trustworthy%20appearance%2C%20business%20formal%20attire&width=300&height=300&seq=bram&orientation=squarish"
    },
    {
      name: "Nora Bakker",
      role: "Klantenservice",
      image: "https://readdy.ai/api/search-image?query=Professional%20customer%20service%20representative%20headshot%2C%20warm%20friendly%20smile%2C%20welcoming%20expression%2C%20modern%20office%20background%2C%20approachable%20demeanor&width=300&height=300&seq=nora&orientation=squarish"
    }
  ];

  const whyChooseUs = [
    {
      title: "Specialist in ZZP/MKB",
      description: "We begrijpen de unieke uitdagingen van kleine bedrijven en ZZP'ers.",
      icon: "ri-user-star-line"
    },
    {
      title: "Resultaatgericht",
      description: "Alles wat we doen is gericht op meetbare resultaten en ROI.",
      icon: "ri-target-line"
    },
    {
      title: "Complete service",
      description: "Van strategie tot uitvoering, alles onder één dak.",
      icon: "ri-service-line"
    },
    {
      title: "Heldere rapportages",
      description: "Transparante communicatie over prestaties en resultaten.",
      icon: "ri-bar-chart-line"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <a href="/" className="text-2xl font-bold text-[#0A66C2]" style={{ fontFamily: '"Pacifico", serif' }}>
                StarSales
              </a>
            </div>
            <div className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-700 hover:text-[#0A66C2] font-medium transition-colors">Home</a>
              <a href="/over-ons" className="text-gray-900 hover:text-[#0A66C2] font-medium transition-colors">Over ons</a>
              <a href="/contact" className="text-gray-700 hover:text-[#0A66C2] font-medium transition-colors">Contact</a>
            </div>
            <div className="flex items-center space-x-4">
              <a href="tel:097010224137" className="text-[#0A66C2] hover:text-[#F57C00] font-medium transition-colors">
                0970 102 241 37
              </a>
              <button className="bg-[#F57C00] text-white px-4 py-2 rounded-full font-medium hover:bg-[#E65100] transition-colors whitespace-nowrap cursor-pointer">
                Gratis check
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#0A66C2] to-[#1976D2] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Over <span className="text-[#F57C00]">StarSales</span>
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-4xl mx-auto" style={{ fontFamily: '"Inter", sans-serif' }}>
              Bij StarSales B.V. combineren we strak design met datagedreven marketing. Wij maken sites die klanten aantrekken en campagnes die renderen.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Onze missie
              </h2>
              <p className="text-xl text-gray-600 mb-6" style={{ fontFamily: '"Inter", sans-serif' }}>
                ZZP & kleine bedrijven eenvoudig online laten groeien
              </p>
              <p className="text-gray-700 mb-8" style={{ fontFamily: '"Inter", sans-serif' }}>
                We geloven dat elke ondernemer toegang moet hebben tot professionele online marketing, ongeacht de grootte van het bedrijf. Daarom hebben we StarSales opgericht: om ZZP'ers en kleine bedrijven te helpen concurreren met de grote spelers.
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#F57C00] rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Korte lijnen</h3>
                    <p className="text-gray-600">Direct contact met je vaste aanspreekpunt</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#F57C00] rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Transparant</h3>
                    <p className="text-gray-600">Heldere communicatie over kosten en resultaten</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#F57C00] rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Snel</h3>
                    <p className="text-gray-600">Snelle implementatie en zichtbare resultaten</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#F57C00] rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Optimaliseren</h3>
                    <p className="text-gray-600">Continue verbetering van prestaties</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20digital%20marketing%20team%20collaborating%20in%20bright%20office%20space%2C%20diverse%20professionals%20working%20together%20on%20marketing%20campaigns%2C%20laptops%20and%20monitors%20showing%20analytics%2C%20creative%20brainstorming%20session%2C%20contemporary%20workspace%20design&width=600&height=500&seq=mission&orientation=landscape"
                alt="Ons team aan het werk"
                className="w-full h-auto rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Ons team
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" style={{ fontFamily: '"Inter", sans-serif' }}>
              Maak kennis met de experts die jouw online succes mogelijk maken
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
            {teamMembers.map((member, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 text-center shadow-sm border border-gray-100 hover:shadow-lg transition-shadow">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-24 h-24 rounded-full mx-auto mb-4 object-cover"
                />
                <h3 className="text-lg font-bold text-gray-900 mb-2" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  {member.name}
                </h3>
                <p className="text-[#0A66C2] font-medium" style={{ fontFamily: '"Inter", sans-serif' }}>
                  {member.role}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Waarom kiezen voor ons?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" style={{ fontFamily: '"Inter", sans-serif' }}>
              Dit maakt ons de ideale partner voor jouw online groei
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {whyChooseUs.map((item, index) => (
              <div key={index} className="text-center group">
                <div className="w-16 h-16 bg-[#0A66C2] text-white rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-[#F57C00] transition-colors">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  {item.title}
                </h3>
                <p className="text-gray-600" style={{ fontFamily: '"Inter", sans-serif' }}>
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gradient-to-r from-[#0A66C2] to-[#1976D2] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl md:text-5xl font-bold text-[#F57C00] mb-2">150+</div>
              <div className="text-lg text-blue-100">Tevreden klanten</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-[#F57C00] mb-2">300+</div>
              <div className="text-lg text-blue-100">Websites gebouwd</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-[#F57C00] mb-2">€2M+</div>
              <div className="text-lg text-blue-100">Advertentiebudget beheerd</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-[#F57C00] mb-2">5</div>
              <div className="text-lg text-blue-100">Jaar ervaring</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Poppins", sans-serif' }}>
            Klaar om samen te werken?
          </h2>
          <p className="text-xl text-gray-600 mb-8" style={{ fontFamily: '"Inter", sans-serif' }}>
            Laten we kennismaken en bespreken hoe wij jouw bedrijf kunnen helpen groeien.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-[#F57C00] text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#E65100] transition-colors whitespace-nowrap cursor-pointer">
              Gratis marketingcheck
            </button>
            <a href="/contact" className="bg-[#0A66C2] text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#1976D2] transition-colors whitespace-nowrap cursor-pointer inline-block">
              Neem contact op
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-12">
            <div className="md:col-span-2">
              <div className="flex items-center mb-6">
                <span className="text-3xl font-bold text-[#0A66C2]" style={{ fontFamily: '"Pacifico", serif' }}>
                  StarSales
                </span>
              </div>
              <p className="text-gray-300 mb-6 max-w-md" style={{ fontFamily: '"Inter", sans-serif' }}>
                StarSales B.V. helpt ZZP en kleine bedrijven groeien met websites, Google Ads, social media advertenties en meer.
              </p>
              <div className="space-y-2 text-gray-300">
                <p>Mgr. Cornelis Veermanlaan 63</p>
                <p>1131 KE Volendam</p>
                <p>KvK: 97377562</p>
                <p>Tel: 0970 102 241 37</p>
                <p>E-mail: info@starsales.nl</p>
              </div>
            </div>
            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Diensten
              </h3>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Websites</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Google Ads</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Social Media Ads</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">SEO</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Hosting</a></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Links
              </h3>
              <ul className="space-y-2 text-gray-300">
                <li><a href="/privacy" className="hover:text-[#F57C00] transition-colors">Privacy</a></li>
                <li><a href="/cookies" className="hover:text-[#F57C00] transition-colors">Cookies</a></li>
                <li><a href="/voorwaarden" className="hover:text-[#F57C00] transition-colors">Voorwaarden</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 StarSales B.V. Alle rechten voorbehouden.
            </p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-[#F57C00] transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#F57C00] transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#F57C00] transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
